// extracted by mini-css-extract-plugin
export var threeDWithProBadge = "styles-module__threeDWithProBadge___SyW4z";
export var proBadge = "styles-module__proBadge___EC7E5";